import Button, { ButtonSize } from 'components/Form/Button'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Summary from '../Summary'
import { EstimatedFrequencyEmissionsProps } from './types'
import service from './service'
import './EstimatedFrequencyEmissions.scss'

const EstimatedFrequencyEmissions: React.FC<EstimatedFrequencyEmissionsProps> = ({
  campaignId,
}) => {
  const { t } = useTranslation()
  const [estimatedImpressions, setEstimatedImpressions] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const handleClick = () => {
    void service.getCampaignImpressionsBasedOnFrequency({
      campaignId,
      setEstimatedImpressions,
      setLoading,
    })
  }

  return (
    <Summary
      title={t(`form.campaign.summary.frequency`)}
      quantity={estimatedImpressions}
      isLoading={loading}
    >
      {campaignId && (
        <Button
          className='EstimatedFrequencyEmissions__button'
          size={ButtonSize.SMALL}
          onClick={handleClick}
        >
          {t('form.campaign.summary.recalculate')}
        </Button>
      )}
    </Summary>
  )
}

export default EstimatedFrequencyEmissions
